import {compileAndLink} from './utils.js';
import {WIDTH} from 'components/effects/plane/constants.js';

export const setupSmokeShaders = (gl) => {
    let pointSize = (10.0 * WIDTH/600.0).toFixed(1);
    console.log('pointSize = ', pointSize);
    return compileAndLink(
        gl,
        [
            'precision mediump float;',
            'attribute vec4 aPosition;',
            'attribute float vertColor;',
            'varying float fragColor;',
            'void main() {',
            `gl_PointSize = ${pointSize};`,
            'gl_Position = aPosition;',
            'fragColor = vertColor;',
            '}'
        ].join('\n'),
        [
            'precision mediump float;',
            'varying float fragColor;',
            'void main() {',
            //'gl_FragColor = vec4(0.196,0.198,0.2,0.1*fragColor);',
            'gl_FragColor = vec4(1,1,1,0.1*fragColor);',
            '}'
        ].join('\n'));
};

export const setupMacroShaders = (gl) => {
    return compileAndLink(
        gl,
        // vertex shader
`
precision mediump float;
attribute vec4 a_position;
void main() {
   gl_Position = a_position;
}
`,
        // fragment shader
        `
precision mediump float;

uniform vec4 u_color;

void main() {
   gl_FragColor = u_color;
}
`);
};


